import {
    BreakpointRangeProps,
    EmptyState,
    SelectionCardGroup,
    SelectionCardGroupProps,
    Stack,
} from '@optimus-web/core';
import { getTemplateColumnsGridSize } from '../../utils/getTemplateColumnsGridSize';
import { CurrencySelectDialogTexts } from '../types';
import { SuggestedCurrencies } from './SuggestedCurrencies';

interface FilteredCurrencySectionProps extends BreakpointRangeProps {
    texts: CurrencySelectDialogTexts;
    suggestedCurrenciesCardGroupOptions: SelectionCardGroupProps['options'];
    filteredCurrenciesCardGroupOptions: SelectionCardGroupProps['options'];
    handleChange: (currencyCode: string | undefined) => void;
}

export const FilteredCurrencySection = ({
    filteredCurrenciesCardGroupOptions,
    suggestedCurrenciesCardGroupOptions,
    breakpointRange,
    texts,
    handleChange,
}: FilteredCurrencySectionProps) => {
    if (filteredCurrenciesCardGroupOptions.length === 0) {
        return (
            <Stack vertical spacing="300">
                <EmptyState
                    pictogram="search"
                    primaryText={texts.filteredCurrenciesEmptyStatePrimary}
                    secondaryText={texts.filteredCurrenciesEmptyStateSecondary}
                />

                <SuggestedCurrencies
                    suggestedCurrenciesTitleText={texts.suggestedCurrenciesTitle}
                    suggestedCurrenciesAriaLabelText={texts.suggestedCurrenciesAriaLabel}
                    suggestedCurrenciesCardGroupOptions={suggestedCurrenciesCardGroupOptions}
                    handleChange={handleChange}
                    breakpointRange={breakpointRange}
                />
            </Stack>
        );
    }

    return (
        <SelectionCardGroup
            inputValue={[]}
            onChange={(e_, newValue) => handleChange(newValue[0])}
            options={filteredCurrenciesCardGroupOptions}
            showSelector={false}
            templateColumns={getTemplateColumnsGridSize(breakpointRange)}
            type="checkbox"
            aria-label={texts.filteredCurrenciesAriaLabel}
        />
    );
};
